import React from 'react';
import { CssBaseline, Grid, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';

import SubTitle from '../components/Text/SubTitle';
import { EVENT_IMG } from '../constatns';

import { IoLocationSharp, IoCalendarSharp } from 'react-icons/io5';

const styles = (theme) => ({
  container: {
    padding: theme.spacing(3, 0),
    textAlign: 'center',
  },
});

const Welcome_Img = [
  {
    img: 'wr_1.png',
  },
  {
    img: 'wr_2.png',
  },
  {
    img: 'wr_3.png',
  },
];

const Gala_Img = [
  {
    img: 'gd_1.png',
  },
  {
    img: 'gd_2.png',
  },
  {
    img: 'gd_3.png',
  },
];

class SocialEvent extends React.Component {
  // constructor(props) {
  //   super(props);
  // }
  render() {
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={1} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={11} sm={10} md={9} lg={8} style={{ maxWidth: '1920px' }}>
              <MainTitle>Social Event</MainTitle>
              {/* === welcome Reception === */}
              <Grid container style={{ marginBottom: 48 }}>
                <SubTitle>Welcome Reception</SubTitle>
                <Grid item xs={12} style={{ paddingLeft: 16, margin: '16px 0' }}>
                  <Grid container alignItems="center" style={{ marginBottom: 20 }}>
                    <IoCalendarSharp size={30} style={{ color: '#237a9d', marginRight: 10 }} />
                    <Grid>
                      <Typography style={{ color: '#000', fontWeight: 'bold', fontFamily: 'GmarketSansTTFLight' }}>
                        Day 1: November 11(Fri) 18:30~
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <IoLocationSharp size={30} style={{ color: '#237a9d', marginRight: 10 }} />
                    <Grid>
                      <Typography style={{ color: '#000', fontWeight: 'bold', fontFamily: 'GmarketSansTTFLight' }}>
                        Room 2(Grand Ballroom 2)
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container justifyContent="center">
                    <Grid container justifyContent="center" style={{ maxWidth: 1200 }}>
                      {Welcome_Img.map((welcome) => {
                        return (
                          <div style={{ padding: 8 }}>
                            <img src={`${EVENT_IMG}/info/${welcome.img}`} alt="" style={{ borderRadius: '5px', maxWidth: 320 }} />
                          </div>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* === Gala Dinner === */}
              <Grid container style={{ marginBottom: 48 }}>
                <SubTitle>Gala Dinner</SubTitle>
                <Grid item xs={12} style={{ paddingLeft: 16, margin: '16px 0' }}>
                  <Grid container alignItems="center" style={{ marginBottom: 20 }}>
                    <IoCalendarSharp size={30} style={{ color: '#237a9d', marginRight: 10 }} />
                    <Grid>
                      <Typography style={{ color: '#000', fontWeight: 'bold', fontFamily: 'GmarketSansTTFLight' }}>
                        Day 2: November 12(Sat) 18:30~21:00
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container alignItems="center" item xs={12}>
                    <IoLocationSharp size={30} style={{ color: '#237a9d', marginRight: 10 }} />
                    <Grid>
                      <Typography style={{ color: '#000', fontWeight: 'bold', fontFamily: 'GmarketSansTTFLight' }}>
                        Room 1+2+3(Grand Ballroom 1+2+3)
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container justifyContent="center">
                    <Grid container justifyContent="center" style={{ maxWidth: 1200 }}>
                      {Gala_Img.map((gala) => {
                        return (
                          <div style={{ padding: 8 }}>
                            <img src={`${EVENT_IMG}/info/${gala.img}`} style={{ borderRadius: '5px', maxWidth: 320 }} alt="" />
                          </div>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SocialEvent);
